import { Text, View } from "@react-pdf/renderer";

function FifthRow({ motor }) {
  function formatDate(inputDate) {
    if (!inputDate) {
      return "";
    }

    if (typeof inputDate === 'string' && inputDate.match(/^\d{4}-\d{2}-\d{2}/)) {
      const [year, month, day] = inputDate.substring(0, 10).split('-');
      return `${month}/${day}/${year}`;
    }

    const date = new Date(inputDate);
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const day = String(date.getUTCDate()).padStart(2, "0");
    const year = date.getUTCFullYear();
    return `${month}/${day}/${year}`;
  }

  return (
    <View style={{ flexDirection: "row", height: "40px" }}>
      <View
        style={{
          width: "4%",
          borderRight: "1px solid black",
          borderBottom: "1px solid black",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <Text style={{ textAlign: "center" }}>C</Text>
      </View>
      <View
        style={{
          width: "25%",
          borderRight: "1px solid black",
          borderBottom: "1px solid black",
        }}
      >
        <Text
          style={{
            textAlign: "center",
            fontSize: 12,
            paddingTop: 10,
          }}
        >
          Motor Truck Cargo
        </Text>
      </View>
      <View
        style={{
          width: "4%",
          borderRight: "1px solid black",
          borderBottom: "1px solid black",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      ></View>
      <View
        style={{
          width: "4%",
          borderRight: "1px solid black",
          borderBottom: "1px solid black",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      ></View>
      <View
        style={{
          width: "18%",
          borderRight: "1px solid black",
          borderBottom: "1px solid black",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <Text style={{ textAlign: "center" }}>
          {motor && motor.policy_number}
        </Text>
      </View>
      <View
        style={{
          width: "9%",
          borderRight: "1px solid black",
          borderBottom: "1px solid black",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <Text style={{ textAlign: "center" }}>
          {motor && formatDate(motor.policy_effective_date)}
        </Text>
      </View>
      <View
        style={{
          width: "9%",
          borderRight: "1px solid black",
          borderBottom: "1px solid black",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <Text style={{ textAlign: "center" }}>
          {motor && formatDate(motor.policy_expiration_date)}
        </Text>
      </View>
      <View style={{ width: "29%", borderBottom: "1px solid black" }}>
        <View
          style={{
            flexDirection: "row",
            width: "100%",
            height: "100%",
            fontFamily: "Helvetica",
          }}
        >
          <View
            style={{
              flex: "1",
              borderRight: "1px solid black",
              height: "100%",
              fontSize: "5px",
            }}
          >
            <Text
              style={{
                borderBottom: "1px solid black",
                paddingLeft: "2px",
                paddingTop: "6px",
                height: "50%",
              }}
            >
              Limit
            </Text>
            <Text
              style={{
                paddingLeft: "2px",
                paddingTop: "4px",
              }}
            >
              Deductible
            </Text>
          </View>
          <View style={{ flex: "1", fontSize: "6px" }}>
            <View
              style={{
                flexDirection: "row",
                borderBottom: "1px solid black",
                paddingTop: "4px",
                height: "50%",
              }}
            >
              {motor && (
                <>
                  <Text
                    style={{ paddingHorizontal: "2px", textAlign: "center" }}
                  >
                    {new Intl.NumberFormat("en-US", {
                      style: "currency",
                      currency: "USD",
                    }).format(motor.limit)}
                  </Text>
                </>
              )}
            </View>
            <View style={{ flexDirection: "row", paddingTop: "4px" }}>
              {motor && (
                <>
                  <Text
                    style={{ paddingHorizontal: "2px", textAlign: "center" }}
                  >
                    {new Intl.NumberFormat("en-US", {
                      style: "currency",
                      currency: "USD",
                    }).format(motor.deductible)}
                  </Text>
                </>
              )}
            </View>
          </View>
        </View>
      </View>
    </View>
  );
}
export default FifthRow;
